<template>
  <div class="base_breadcrumbs d-flex justify-content-between">
        <ul>
            <li>
                <a @click="$emit('handleClickBreadcrumb1')" class="router-link-active">
                    <span>{{title1}}</span>
                </a>
            </li>
            <li @click="$emit('handleClickBreadcrumb2')" :class="title3 ? 'router-link-active' : 'active'">
                <a :class="title3 ? '' : 'router-link-active'">
                    <span>{{title2}}</span>
                </a>
            </li>
            <li v-if="title3" @click="$emit('handleClickBreadcrumb3')" class="active">
                <a class="router-link-active">
                    <span>{{title3}}</span>
                </a>
            </li>
        </ul>

        <div v-if="showSlot">
            <slot name="slot-breadcrumb"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title1: String,
        title2: String,
        title3: {
          type: String,
          require: false,
          default: null
        },
        showSlot: Boolean, default: false
    }
}
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
.base_breadcrumbs
    {
      margin-bottom: 25px;

      ul {
        display: flex;
        margin: 0;
        padding: 0;
        list-style: none;
        flex-wrap: wrap;
      }

      li
      {
        position: relative;
        height: 25px;
        background-color: $grey-light;
        border-radius: 4px;

        &:after {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          top: 0;
          right: -10px;
          border-top: 12.5px solid transparent;
          border-bottom: 12.5px solid transparent;
          border-left: 12px solid $grey-light;
          z-index: 2;
        }

        &:not(:first-child):before {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          top: 0;
          left: 0;
          border-top: 12.5px solid transparent;
          border-bottom: 12.5px solid transparent;
          border-left: 12px solid #e5e7e8;
          z-index: 1;
        }

        &.active,
        &:hover
        {
          background-color: var(--v-primary-base);

          &:after {
            border-left: 12px solid var(--v-primary-base);
          }

          span {
            color: white;
            transition: ease 0.4s;
          }
        }

        a {
          display: block;
          font-size: 12px;
          line-height: 15px;
          font-weight: 400;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-decoration: none !important;
          color: #9e9d9d !important;
          padding: 5px 20px 5px 20px;
        }

        a {
          display: block;
          font-size: 12px;
          line-height: 15px;
          font-weight: 400;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-decoration: none !important;
          color: #9e9d9d !important;
          padding: 5px 20px 5px 20px;
        }
      }
    }
</style>
